/** One additive upgrade for tracker journals and durable outing drafts. */
export function openCompanionDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("pw-companion", 11);
    let blocked = false;
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains("sessions")) db.createObjectStore("sessions", { keyPath: "id" });
      if (!db.objectStoreNames.contains("live-meta")) db.createObjectStore("live-meta");
      if (!db.objectStoreNames.contains("live-points")) db.createObjectStore("live-points", { autoIncrement: true });
      // Detailed evidence is read only for an explicit entry, never with a
      // history page. Keep owner deletion indexed without loading raw fixes.
      if (!db.objectStoreNames.contains("session-evidence")) {
        const store = db.createObjectStore("session-evidence", { keyPath: "id" });
        store.createIndex("owner", "offlineOwner");
      }
      if (!db.objectStoreNames.contains("outings")) {
        const store = db.createObjectStore("outings", { keyPath: "key" });
        store.createIndex("owner", "owner");
      }
      if (!db.objectStoreNames.contains("outing-deletions")) {
        const store = db.createObjectStore("outing-deletions", { keyPath: "key" });
        store.createIndex("owner", "owner");
        store.createIndex("pending", ["owner", "status"]);
      }
      const sessions = request.transaction!.objectStore("sessions");
      if (!sessions.indexNames.contains("outing")) sessions.createIndex("outing", "outingId");
      if (!sessions.indexNames.contains("owner")) {
        sessions.createIndex("owner", "offlineOwner");
        const cursor = sessions.openCursor();
        cursor.onsuccess = () => {
          const row = cursor.result;
          if (!row) return;
          if (!row.value.offlineOwner) row.update({ ...row.value, offlineOwner: "device" });
          row.continue();
        };
      }
      if (!db.objectStoreNames.contains("stay-drafts")) {
        const store = db.createObjectStore("stay-drafts", { keyPath: "key" });
        store.createIndex("owner", "owner");
      }
      if (!db.objectStoreNames.contains("feedback-drafts")) {
        const store = db.createObjectStore("feedback-drafts", { keyPath: "key" });
        store.createIndex("owner", "owner");
      }
      if (!db.objectStoreNames.contains("memory-drafts")) {
        const store = db.createObjectStore("memory-drafts", { keyPath: "key" });
        store.createIndex("owner", "owner");
      }
      if (!db.objectStoreNames.contains("freestyle-drafts")) {
        const store = db.createObjectStore("freestyle-drafts", { keyPath: "key" });
        store.createIndex("owner", "owner");
      }
      if (!db.objectStoreNames.contains("freestyle-community-drafts")) {
        const store = db.createObjectStore("freestyle-community-drafts", { keyPath: "key" });
        store.createIndex("owner", "owner");
      }
      if (!db.objectStoreNames.contains("outing-imports")) db.createObjectStore("outing-imports", { keyPath: "key" });
    };
    request.onblocked = () => { blocked = true; reject(new Error("Close other PeakWave tabs, then retry to prepare offline plans.")); };
    request.onerror = () => reject(request.error);
    request.onsuccess = () => {
      if (blocked) { request.result.close(); return; }
      request.result.onversionchange = () => request.result.close();
      resolve(request.result);
    };
  });
}
